export {
  TRIAL_CLASSROOM_PARAMS_BY_COURSE_ID,
  resolveTrialClassroomParamsByCourseId,
} from '@shared/constants/trial-classroom-params'
